import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import styles from "./Toast.module.css";
import "react-toastify/dist/ReactToastify.css";
import useParams from "../utilities/useParams";
import { useLanguage } from "../contexts/LanguageContext";

const Toast = ({ autoClose = 2000 }) => {
  const params = useParams();
  const { translations } = useLanguage();
  const hasMessage = params.has("msg");
  const accountConfirmation = params.has("account_confirmation_success");

  useEffect(() => {
    if (hasMessage && !accountConfirmation) {
      const msgKey = params.get("msg");
      const text = translations?.[msgKey] || msgKey;
      toast(<p style={{ color: "#022548" }}>{text}</p>);
    }
    if (accountConfirmation) {
      toast(
        <p style={{ color: "#022548" }}>
          {translations?.emailConfirmed || "Email confirmed"}
        </p>
      );
    }
  }, [hasMessage, accountConfirmation, params, translations]);

  return (
    <ToastContainer
      position="top-center"
      autoClose={autoClose}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      closeButton={false}
      draggable
      toastClassName={styles.toast}
      pauseOnHover
    />
  );
};

export default Toast;
